// Phase 7 sub-bucket 18 — admin_deal Saved Views consumer. Mirrors the
// mdf-requests filter-node-mapping pattern from sub-bucket 17.
//
// The admin deals page has one URL-driven chip (`?showClosed=1`) that
// behaves orthogonally to Saved Views — closing-stage visibility is a
// view-level concern, not a filter dimension. So this mapping has nothing
// to round-trip today; the encode helper + hash helper exist so the
// list hook can tuple the active filter into its query key.

import {
  type FilterTree,
} from "@colab/shared";

/**
 * Stable hash of a FilterTree for use as part of a TanStack query key
 * tuple. Two filters that produce identical JSON serialise to the same
 * key; small enough to keep inline without an FNV1a helper.
 */
export function hashFilterTree(tree: FilterTree | null): string {
  if (!tree) return "none";
  return JSON.stringify(tree);
}

/**
 * Base64-encode a FilterTree for transport in the `?filter=` query param.
 * The worker decodes via `atob` + `filterGroupSchema.safeParse`.
 */
export function encodeFilterTreeParam(tree: FilterTree | null): string | null {
  if (!tree) return null;
  return btoa(JSON.stringify(tree));
}
